<!-- Chapter Actions -->
<div class="flex">
  <app-button-group [ngClass]="{'hidden': !selected}" class="mr-2">
    <button
      app-button
      buttonTheme="dark"
      buttonType="flat"
      buttonSize="xsmall"
      matTooltip="Click to capture your starting position. When viewers enter the chapter, this is what they'll see."
      matTooltipPosition="below"
      (click)="handleCaptureClick()">
      Capture
    </button>

    <button
      app-button
      buttonTheme="dark"
      buttonType="flat"
      buttonSize="xsmall"
      [matMenuTriggerFor]="captureMenu">
      <fa-icon icon="caret-down"></fa-icon>
    </button>
  </app-button-group>

  <mat-menu #captureMenu="matMenu">
    <button mat-menu-item (click)="handleCapturePositionClick()">Capture Position Only</button>
    <button mat-menu-item (click)="handleCaptureThumbnailClick()">Capture Thumbnail Only</button>
  </mat-menu>

  <button
    app-button
    buttonTheme="dark"
    buttonType="outline"
    buttonSize="xsmall"
    (click)="handleContentClick()"
    class="mr-1"
    [ngClass]="{'hidden': !selected}"
    matTooltipPosition="below">
    <!-- <fa-icon size="sm" icon="font"></fa-icon> -->
    Edit Text
  </button>

  <button
    app-button
    buttonTheme="dark"
    buttonType="outline"
    buttonSize="xsmall"
    (click)="handleBackgroundColorClick()"
    class="mr-1"
    [ngClass]="{'hidden': !selected}"
    matTooltip="Background Color"
    matTooltipPosition="below">

      <app-swatch-item
        [color]="background$ | async"
        [size]="'small'">
      </app-swatch-item>

  </button>

  <app-button-group [ngClass]="{'hidden': !selected}">
    <button
      app-button
      buttonTheme="dark"
      buttonType="outline"
      buttonSize="xsmall"
      (click)="handleDuplicateClick()"
      matTooltipPosition="below"
      matTooltip="Duplicate This Chapter">
      <fa-icon size="sm" icon="clone"></fa-icon>
      <!-- Duplicate -->
    </button>

    <button
      app-button
      buttonTheme="dark"
      buttonType="outline"
      buttonSize="xsmall"
      (click)="handleRemoveClick()"
      [disabled]="(chapters$ | async)?.length === 1"
      matTooltipPosition="below"
      matTooltip="Remove Chapter">
      <fa-icon size="sm" icon="trash-alt"></fa-icon>
    </button>
  </app-button-group>
</div>